import { bindable, computedFrom } from 'aurelia-framework';

class OdsMenu {
  @bindable appTitle = 'Olapic';
  @bindable avatar = null;
  @bindable avatarItems = [];
  @bindable avatarText = '';
  @bindable currentRoute = null;
  @bindable currentTopRoute = null;
  @bindable customer = null;
  @bindable mainItems = [];
  @bindable onFilter = () => true;
  @bindable subItems = [];
  constructor() {
    this.activeItem = '';
    this.filterRoutes = this.filterRoutes.bind(this);
  }
  filterRoutes(route) {
    const shouldShow = this.onFilter({ route });
    return typeof shouldShow !== 'undefined' ?
      shouldShow :
      true;
  }
  currentRouteChanged(newValue) {
    if (Array.isArray(this.mainItems)) {
      const found = this.mainItems.some((nav) => {
        if (nav.route === newValue) {
          this.activeItem = nav.name;
          return true;
        }

        if (Array.isArray(nav.items)) {
          return nav.items.some((item) => {
            if (item.route === newValue) {
              this.activeItem = nav.name;
              return true;
            }

            return false;
          });
        }

        return false;
      });

      if (!found) {
        this.activeItem = '';
      }
    }
  }
  @computedFrom('avatar')
  get avatarLetterMode() {
    return this.avatar.length === 1;
  }
}

export { OdsMenu };
